export enum JobOrderAttributeDataType {
  FOREIGN_KEY = 0,
  TEXT = 1,
  INT = 2,
  FRACTION = 3,
  DATETIME = 4,
  BOOLEAN = 5,
}

export const SUCCESS_SONNER = {
  className: "success-sonner ",
  descriptionClassName: "success-sonner-description",
};

export const ERROR_SONNER = {
  className: "destructive-sonner",
  descriptionClassName: "destructive-sonner-description",
};
